export class IdePanel {
  public Lookup: string;

  public Panel: string;

  public Title: string;

  public Toolkit: string;
}
